import { useCookieConsent } from "@/hooks/useCookieConsent";
import { CookieBannerContent } from "./cookie-consent/CookieBannerContent";

export const CookieConsent = () => {
  const { showBanner, saveConsent } = useCookieConsent();

  const handleAcceptAll = () => {
    saveConsent({
      necessary: true,
      analytics: true,
      marketing: true,
      preferences: true
    });
  };

  const handleAcceptNecessary = () => {
    saveConsent({
      necessary: true,
      analytics: false,
      marketing: false,
      preferences: false
    });
  };

  if (!showBanner) return null;

  return (
    <div role="region" aria-label="Consentement aux cookies" className="cookie-consent-banner fixed bottom-0 left-0 right-0 bg-background border-t border-border px-4 py-3 z-50">
      <CookieBannerContent
        onAcceptAll={handleAcceptAll}
        onAcceptNecessary={handleAcceptNecessary}
      />
    </div>
  );
};